import { useEffect } from 'react';
import { Modal } from '@/shared/ui';
import { useAuth } from '../useAuth';
import { useAuthModal } from '../model/authModalStore';
import { AuthPanel } from './AuthPanel';

/**
 * Global auth modal, mounted once in the root layout and opened via `useAuthModal`.
 * Closes itself as soon as the user becomes authenticated.
 */
export function AuthModal() {
  const { isOpen, mode, close, setMode } = useAuthModal();
  const { status } = useAuth();

  useEffect(() => {
    if (isOpen && status === 'authenticated') close();
  }, [isOpen, status, close]);

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
      title="Account"
      hideHeader
      size="md"
    >
      <div className="px-7 pb-7 pt-8">
        <AuthPanel mode={mode} onModeChange={setMode} onSuccess={close} />
      </div>
    </Modal>
  );
}
